export const statesWithCities = () => {
    return[
    //     {
    //     name: "Andaman and Nicobar",
    //     cities: ["Car Nicobar", "Digipur", "Diglipur", "Ferrargunj", "Hut Bay", "Mayabunder", "Nancowry", "Port Blair", "Rangat"]
    //     },
    //     {
    //     name: "Andhra Pradesh",
    //     cities: ['Adilabad',
	// 		'Anantapur',
	// 		'Chittoor',
	// 		'Kakinada',
	// 		'Guntur',
	// 		'Hyderabad',
	// 		'Karimnagar',
	// 		'Khammam',
	// 		'Krishna',
	// 		'Kurnool',
	// 		'Mahbubnagar',
	// 		'Medak',
	// 		'Nalgonda',
	// 		'Nizamabad',
	// 		'Ongole',
	// 		'Srikakulam',
	// 		'Nellore',
	// 		'Visakhapatnam',
	// 		'Vizianagaram',
	// 		'Warangal',
	// 		'Eluru',
	// 		'Kadapa']
    //     },
    //     {
    //     name: "Arunachal Pradesh",
    //     cities: ['Anjaw',
	// 		'Changlang',
	// 		'East Siang',
	// 		'Kurung Kumey',
	// 		'Lohit',
	// 		'Lower Dibang Valley',
	// 		'Lower Subansiri',
	// 		'Papum Pare',
	// 		'Tawang',
	// 		'Tirap',
	// 		'Dibang Valley',
	// 		'Upper Siang',
	// 		'Upper Subansiri',
	// 		'West Kameng',
	// 		'West Siang']
    //     },
    //     {
    //     name: "Assam",
    //     cities: ['Baksa',
	// 		'Barpeta',
	// 		'Bongaigaon',
	// 		'Cachar',
	// 		'Chirang',
	// 		'Darrang',
	// 		'Dhemaji',
	// 		'Dima Hasao',
	// 		'Dhubri',
	// 		'Dibrugarh',
	// 		'Goalpara',
	// 		'Golaghat',
	// 		'Hailakandi',
	// 		'Jorhat',
	// 		'Kamrup',
	// 		'Kamrup Metropolitan',
	// 		'Karbi Anglong',
	// 		'Karimganj',
	// 		'Kokrajhar',
	// 		'Lakhimpur',
	// 		'Marigaon',
	// 		'Nagaon',
	// 		'Nalbari',
	// 		'Sibsagar',
	// 		'Sonitpur',
	// 		'Tinsukia',
	// 		'Udalguri']
    //     },
    //     {
    //         name: "Bihar",
    //         cities: [
    //             'Araria',
	// 		'Arwal',
	// 		'Aurangabad',
	// 		'Banka',
	// 		'Begusarai',
	// 		'Bhagalpur',
	// 		'Bhojpur',
	// 		'Buxar',
	// 		'Darbhanga',
	// 		'East Champaran',
	// 		'Gaya',
	// 		'Gopalganj',
	// 		'Jamui',
	// 		'Jehanabad',
	// 		'Kaimur',
	// 		'Katihar',
	// 		'Khagaria',
	// 		'Kishanganj',
	// 		'Lakhisarai',
	// 		'Madhepura',
	// 		'Madhubani',
	// 		'Munger',
	// 		'Muzaffarpur',
	// 		'Nalanda',
	// 		'Nawada',
	// 		'Patna',
	// 		'Purnia',
	// 		'Rohtas',
	// 		'Saharsa',
	// 		'Samastipur',
	// 		'Saran',
	// 		'Sheikhpura',
	// 		'Sheohar',
	// 		'Sitamarhi',
	// 		'Siwan',
	// 		'Supaul',
	// 		'Vaishali',
	// 		'West Champaran',
	// 		'Chandigarh'
    //         ]
    //     },
    //     {
    //         name: "Chandigarh",
    //         cities: ['Chandigarh']
    //     },
    //     {
    //         name: "Chhattisgarh",
    //         cities: ['Bastar',
	// 		'Bijapur',
	// 		'Bilaspur',
	// 		'Dantewada',
	// 		'Dhamtari',
	// 		'Durg',
	// 		'Jashpur',
	// 		'Janjgir-Champa',
	// 		'Korba',
	// 		'Koriya',
	// 		'Kanker',
	// 		'Kabirdham (Kawardha)',
	// 		'Mahasamund',
	// 		'Narayanpur',
	// 		'Raigarh',
	// 		'Rajnandgaon',
	// 		'Raipur',
	// 		'Surguja']
    //     },
    //     {
    //         name:"Dadra and Nagar Haveli",
    //         cities: ['Dadra and Nagar Haveli']
    //     },
    //     {
    //         name:"Daman and Diu",
    //         cities: ['Daman', 'Diu']
    //     },
    //     {
    //         name:"Delhi",
    //         cities:['Central Delhi',
	// 		'East Delhi',
	// 		'New Delhi',
	// 		'North Delhi',
	// 		'North East Delhi',
	// 		'North West Delhi',
	// 		'South Delhi',
	// 		'South West Delhi',
	// 		'West Delhi']
    //     },
    //     {
    //         name:"Goa",
    //         cities: ['North Goa',
	// 		'South Goa']
    //     },
    //     {
    //         name:"Gujarat",
    //         cities: ['Ahmedabad',
	// 		'Amreli district',
	// 		'Anand',
	// 		'Banaskantha',
	// 		'Bharuch',
	// 		'Bhavnagar',
	// 		'Dahod',
	// 		'The Dangs',
	// 		'Gandhinagar',
	// 		'Jamnagar',
	// 		'Junagadh',
	// 		'Kutch',
	// 		'Kheda',
	// 		'Mehsana',
	// 		'Narmada',
	// 		'Navsari',
	// 		'Patan',
	// 		'Panchmahal',
	// 		'Porbandar',
	// 		'Rajkot',
	// 		'Sabarkantha',
	// 		'Surendranagar',
	// 		'Surat',
	// 		'Vyara',
	// 		'Vadodara',
	// 		'Valsad']
    //     },
    //     {
    //         name:"Haryana",
    //         cities: [
    //             'Ambala',
	// 		'Bhiwani',
	// 		'Faridabad',
	// 		'Fatehabad',
	// 		'Gurgaon',
	// 		'Hissar',
	// 		'Jhajjar',
	// 		'Jind',
	// 		'Karnal',
	// 		'Kaithal',
	// 		'Kurukshetra',
	// 		'Mahendragarh',
	// 		'Mewat',
	// 		'Palwal',
	// 		'Panchkula',
	// 		'Panipat',
	// 		'Rewari',
	// 		'Rohtak',
	// 		'Sirsa',
	// 		'Sonipat',
	// 		'Yamuna Nagar'
    //         ]
    //     },
    //     {
    //         name:'Himachal Pradesh',
    //         cities: [
	// 		'Bilaspur',
	// 		'Chamba',
	// 		'Hamirpur',
	// 		'Kangra',
	// 		'Kinnaur',
	// 		'Kullu',
	// 		'Lahaul and Spiti',
	// 		'Mandi',
	// 		'Shimla',
	// 		'Sirmaur',
	// 		'Solan',
	// 		'Una'
	//         ]
    //     },
    //     {
    //         name:'Jammu and Kashmir',
    //         cities: [
	// 		'Anantnag',
	// 		'Badgam',
	// 		'Bandipora',
	// 		'Baramulla',
	// 		'Doda',
	// 		'Ganderbal',
	// 		'Jammu',
	// 		'Kargil',
	// 		'Kathua',
	// 		'Kishtwar',
	// 		'Kupwara',
	// 		'Kulgam',
	// 		'Leh',
	// 		'Poonch',
	// 		'Pulwama',
	// 		'Rajauri',
	// 		'Ramban',
	// 		'Reasi',
	// 		'Samba',
	// 		'Shopian',
	// 		'Srinagar',
	// 		'Udhampur',
	//         ]
    //     },
    //     {
    //         name:'Jharkhand',
    //         cities: [
	// 		'Bokaro',
	// 		'Chatra',
	// 		'Deoghar',
	// 		'Dhanbad',
	// 		'Dumka',
	// 		'East Singhbhum',
	// 		'Garhwa',
	// 		'Giridih',
	// 		'Godda',
	// 		'Gumla',
	// 		'Hazaribag',
	// 		'Jamtara',
	// 		'Khunti',
	// 		'Koderma',
	// 		'Latehar',
	// 		'Lohardaga',
	// 		'Pakur',
	// 		'Palamu',
	// 		'Ramgarh',
	// 		'Ranchi',
	// 		'Sahibganj',
	// 		'Seraikela Kharsawan',
	// 		'Simdega',
	// 		'West Singhbhum',
	//         ]
    //     },
    //     {
    //         name:'Karnataka',
    //         cities: [
	// 		'Bagalkot',
	// 		'Bangalore Rural',
	// 		'Bangalore Urban',
	// 		'Belgaum',
	// 		'Bellary',
	// 		'Bidar',
	// 		'Bijapur',
	// 		'Chamarajnagar',
	// 		'Chikkamagaluru',
	// 		'Chikkaballapur',
	// 		'Chitradurga',
	// 		'Davanagere',
	// 		'Dharwad',
	// 		'Dakshina Kannada',
	// 		'Gadag',
	// 		'Gulbarga',
	// 		'Hassan',
	// 		'Haveri district',
	// 		'Kodagu',
	// 		'Kolar',
	// 		'Koppal',
	// 		'Mandya',
	// 		'Mysore',
	// 		'Raichur',
	// 		'Shimoga',
	// 		'Tumkur',
	// 		'Udupi',
	// 		'Uttara Kannada',
	// 		'Ramanagara',
	// 		'Yadgir',
	//         ]
    //     },
    //     {
    //      name:'Kerala',
    //      cities: [
    //     'Alappuzha',
    //     'Ernakulam',
    //     'Idukki',
    //     'Kannur',
    //     'Kasaragod',
    //     'Kollam',
    //     'Kottayam',
    //     'Kozhikode',
    //     'Malappuram',
    //     'Palakkad',
    //     'Pathanamthitta',
    //     'Thrissur',
    //     'Thiruvananthapuram',
    //     'Wayanad',
    //         ]
    //     },
    //     {
    //     name:'Madhya Pradesh',
    //     cities: [
    //         'Alirajpur',
	// 		'Anuppur',
	// 		'Ashok Nagar',
	// 		'Balaghat',
	// 		'Barwani',
	// 		'Betul',
	// 		'Bhind',
	// 		'Bhopal',
	// 		'Burhanpur',
	// 		'Chhatarpur',
	// 		'Chhindwara',
	// 		'Damoh',
	// 		'Datia',
	// 		'Dewas',
	// 		'Dhar',
	// 		'Dindori',
	// 		'Guna',
	// 		'Gwalior',
	// 		'Harda',
	// 		'Hoshangabad',
	// 		'Indore',
	// 		'Jabalpur',
	// 		'Jhabua',
	// 		'Katni',
	// 		'Khandwa (East Nimar)',
	// 		'Khargone (West Nimar)',
	// 		'Mandla',
	// 		'Mandsaur',
	// 		'Morena',
	// 		'Narsinghpur',
	// 		'Neemuch',
	// 		'Panna',
	// 		'Rewa',
	// 		'Rajgarh',
	// 		'Ratlam',
	// 		'Raisen',
	// 		'Sagar',
	// 		'Satna',
	// 		'Sehore',
	// 		'Seoni',
	// 		'Shahdol',
	// 		'Shajapur',
	// 		'Sheopur',
	// 		'Shivpuri',
	// 		'Sidhi',
	// 		'Singrauli',
	// 		'Tikamgarh',
	// 		'Ujjain',
	// 		'Umaria',
	// 		'Vidisha',
	// ]
    // },
    {
        name:'Maharashtra',
		cities :[
			'Achalpur',
			'Aheri',
			'Ahmednagar',
			'Ahmedpur',
			'Ajara',
			'Akkalkot',
			'Akkalkuva',
			'Akluj',
			'Akola',
			'Akole',
			'Akot',
			'Alibag',
			'Amalner',
			'Ambad',
			'Ambajogai',
			'Ambegaon',
			'Ambernath',
			'Ambewadgaon',
			'Amgaon',
			'Amravati',
			'Anjaneri',
			'Anjangaon',
			'Ardhapur',
			'Arjuni',
			'Armori',
			'Arvi',
			'Ashti',
			'Atpadi',
			'Aundha Nagnath',
			'Aurangabad',
			'Ausa',
			'Babhulgaon',
			'Badnapur',
			'Balapur',
			'Balharshah',
			'Baramati',
			'Barshi',
			'Barsi Takli',
			'Basmat',
			'Bavada',
			'Beed',
			'Bhadgaon',
			'Bhadravati',
			'Bhamragarh',
			'Bhandara',
			'Bhatkuli',
			'Bhavaninagar',
			'Bhikarkheda',
			'Bhiwandi',
			'Bhiwapur',
			'Bhokar',
			'Bhokardan',
			'Bhoom',
			'Bhusawal',
			'Bhuye',
			'Biloli',
			'Bodwad',
			'Buldhana',
			'Chakur',
			'Chalisgaon',
			'Chamorshi',
			'Chandgad',
			'Chandrapur',
			'Chandsaili',
			'Chandur',
			'Chandur Bazar',
			'Chandur Railway',
			'Chandwad',
			'Chikhaldara',
			'Chikhli',
			'Chimur',
			'Chiplun',
			'Chopda',
			'Dahanu',
			'Dahiwadi',
			'Dapoli',
			'Darwha',
			'Daryapur Banosa',
			'Daund',
			'Deaulgaon Raja',
			'Degloor',
			'Deoni',
			'Desaiganj',
			'Deulgaon Mahi',
			'Devgad',
			'Dhadgaon',
			'Dhamangaon',
			'Dharangaon',
			'Dharmabad',
			'Dharni',
			'Dharur',
			'Dholagarwadi',
			'Dhondewadi',
			'Dhule',
			'Digras',
			'Dodamarg',
			'Dombivli',
			'Erandol',
			'Etapalli',
			'Gadchiroli',
			'Gadhinglaj',
			'Gaganbavada',
			'Gaganbawda',
			'Gangakhed',
			'Georai',
			'Ghansawangi',
			'Ghatanji',
			'Ghera Sudhagad',
			'Gherapurandhar',
			'Godhani',
			'Gondia',
			'Gondpipri',
			'Goregaon',
			'Gorewasti',
			'Guhagar',
			'Hadgaon',
			'Harat Kheda',
			'Hatkanangale',
			'Himayatnagar',
			'Hinganghat',
			'Hingna',
			'Hingoli',
			'Indapur',
			'Jalgaon',
			'Jalgaon Jamod',
			'Jalkot',
			'Jalna',
			'Jamkhed',
			'Jath',
			'Javali',
			'Jawhar',
			'Jayakochiwadi',
			'Jintur',
			'Jiwati',
			'Junnar',
			'Kadegaon',
			'Kagal',
			'Kahanapur',
			'Kahatav',
			'Kaij',
			'Kalamb',
			'Kalameshwar',
			'Kalamnuri',
			'Kallam',
			'Kalyan',
			'Kamptee',
			'Kandhar',
			'Kankavali',
			'Kannad',
			'Karad',
			'Karanja',
			'Karanja (Ghadge)',
			'Karanjali',
			'Karjat',
			'Karmala',
			'Karmala Rural',
			'Katol',
			'Kavathe Mahankal',
			'Kelapur',
			'Khalapur',
			'Khamgaon',
			'Khanapur',
			'Khandala',
			'Khatav',
			'Khopoli',
			'Khuldabad',
			'Kikali',
			'Kinwat',
			'Kiwat',
			'Kodgaon Ambad',
			'Kolgaon',
			'Kolhapur',
			'Kopargaon',
			'Korchi',
			'Koregaon',
			'Korpana',
			'Kudal',
			'Kudnur',
			'Kuhi',
			'Kurduwadi',
			'Kurkheda',
			'Lakhandur',
			'Lakhni',
			'Lanja',
			'Latur',
			'Lohara',
			'Lonar',
			'Lonavala',
			'Madha',
			'Mahabaleshwar',
			'Mahad',
			'Mahagaon',
			'Malegaon',
			'Malegaon Bk',
			'Malegaon Kannad',
			'Malkapur',
			'Malshiras',
			'Malvan',
			'Manchar',
			'Mandangad',
			'Mandur',
			'Mangalwedha',
			'Mangaon',
			'Mangrulpir',
			'Mantha',
			'Manwath',
			'Maregaon',
			'Matheran',
			'Mauda',
			'Mawalgaon',
			'Mehkar',
			'Mhasala',
			'Mhase',
			'Mira Bhayandar',
			'Miraj',
			'Mohadi',
			'Mohdal Bhanguda',
			'Mohol',
			'Mohopada',
			'Mokhada',
			'Morshi',
			'Motala',
			'Mudkhed',
			'Mukhed',
			'Muktainagar',
			'Mulchera',
			'Mulshi',
			'Mumbai',
			'Mumbai City',
			'Mumbai Suburban',
			'Mundhe Tarf Chiplun',
			'Murbad',
			'Murtizapur',
			'Murud',
			'Murud rural',
			'Nagbhid',
			'Nagbhir',
			'Nagpur',
			'Naigaon',
			'Nala Sopara',
			'Nanded',
			'Nandgaon Khandeshwar',
			'Nandura',
			'Nandurbar',
			'Narkhed',
			'Nashik',
			'Navapur',
			'Navi Mumbai',
			'Naygaon',
			'Newasa',
			'Nilanga',
			'Niphad',
			'Omerga',
			'Oros',
			'Osmanabad',
			'Pachora',
			'Paithan',
			'Palghar',
			'Palus',
			'Pandharpur',
			'Panhala',
			'Panumbre Tarf Shirala',
			'Panvel',
			'Paranda',
			'Paratwada',
			'Parbhani',
			'Parli',
			'Parner',
			'Parola',
			'Parsamal',
			'Parshivni',
			'Partur',
			'Pathardi',
			'Patoda',
			'Pauni',
			'Peint',
			'Pen',
			'Peth',
			'Peth Umri',
			'Phaltan',
			'Phulambri',
			'Pimpalgaon Tarf Khed',
			'Pimpri Ashti',
			'Pimpri Bk.Pr.Pachora',
			'Pimpri-Chinchwad',
			'Poladpur',
			'Pombhurna',
			'Pulgaon',
			'Pune',
			'Purna',
			'Pusad',
			'Radhanagari',
			'Rahata',
			'Rahta Pimplas',
			'Rahuri',
			'Raigad',
			'Rajapur',
			'Rajgurunagar',
			'Rajura',
			'Ralegaon',
			'Ramkheda',
			'Ramtek',
			'Ranala',
			'Ranewadi',
			'Ratnagiri',
			'Raver',
			'Risod',
			'Roha',
			'Sadak Arjuni',
			'Sakoli',
			'Sakri',
			'Salekasa',
			'Samudrapur',
			'Sangameshwar',
			'Sangamner',
			'Sangli',
			'Sangola',
			'Sangrampur',
			'Saoli',
			'Saswad',
			'Satana',
			'Satara',
			'Savner',
			'Sawali',
			'Sawantwadi',
			'Seloo',
			'Selu',
			'Sengaon',
			'Shahada',
			'Shahade',
			'Shahapur',
			'Shahuwadi',
			'Shegaon',
			'Shekhmirewadi',
			'Shevgaon',
			'Shirala',
			'Shirol',
			'Shirpur',
			'Shirur',
			'Shirur Anantpal',
			'Shirwal',
			'Shrigonda',
			'Shrirampur',
			'Shrivardhan',
			'Sillod',
			'Sindewahi',
			'Sindhudurg',
			'Sindkhed Raja',
			'Sindkheda',
			'Sinnar',
			'Sironcha',
			'Sironcha Ry.',
			'Solapur',
			'Sonpeth',
			'Soygaon',
			'Surgana',
			'Takali Ambad',
			'Talasari',
			'Taloda',
			'Talvat Khed',
			'Talvat Pal',
			'Tambale',
			'Tasgaon',
			'Telhara',
			'Tembhari',
			'Teosa',
			'Thane',
			'Tirora',
			'Trimbak',
			'Tuljapur',
			'Tumsar',
			'Udgir',
			'Umarkhed',
			'Umred',
			'Vadgaon',
			'Vaibhavwadi',
			'Vaijapur',
			'Varvand',
			'Vasai',
			'Velhe',
			'Vengurla',
			'Vikramgad',
			'Virar',
			'Wada',
			'Wadhe',
			'Wadwani',
			'Wai',
			'Walwa',
			'Wani',
			'Wardha',
			'Warora',
			'Warud',
			'Washim',
			'Yavatmal',
			'Yawal',
			'Yeola'
            // 'Ahmednagar',
			// 'Akola',
			// 'Amravati',
			// 'Aurangabad',
			// 'Bhandara',
			// 'Beed',
			// 'Buldhana',
			// 'Chandrapur',
			// 'Dhule',
			// 'Gadchiroli',
			// 'Gondia',
			// 'Hingoli',
			// 'Jalgaon',
			// 'Jalna',
			// 'Kolhapur',
			// 'Latur',
			// 'Mumbai City',
			// 'Mumbai suburban',
			// 'Nandurbar',
			// 'Nanded',
			// 'Nagpur',
			// 'Nashik',
			// 'Osmanabad',
			// 'Parbhani',
			// 'Pune',
			// 'Raigad',
			// 'Ratnagiri',
			// 'Sindhudurg',
			// 'Sangli',
			// 'Solapur',
			// 'Satara',
			// 'Thane',
			// 'Wardha',
			// 'Washim',
			// 'Yavatmal',
		]
    },
    // {
    //     name:'Manipur',
	// 	cities :[
    //         'Bishnupur',
	// 		'Churachandpur',
	// 		'Chandel',
	// 		'Imphal East',
	// 		'Senapati',
	// 		'Tamenglong',
	// 		'Thoubal',
	// 		'Ukhrul',
	// 		'Imphal West',
	// ]
    // },
    // {
    //     name:'Meghalaya',
    //     cities :[
	// 		'East Garo Hills',
	// 		'East Khasi Hills',
	// 		'Jaintia Hills',
	// 		'Ri Bhoi',
	// 		'South Garo Hills',
	// 		'West Garo Hills',
	// 		'West Khasi Hills',
	// ]
    // },
    // {
    //     name:'Mizoram',
    //     cities :[
    //         'Aizawl',
	// 		'Champhai',
	// 		'Kolasib',
	// 		'Lawngtlai',
	// 		'Lunglei',
	// 		'Mamit',
	// 		'Saiha',
	// 		'Serchhip',
	// ]
    // },
    // {
    //     name:'Nagaland',
    //     cities :[
	// 		'Dimapur',
	// 		'Kohima',
	// 		'Mokokchung',
	// 		'Mon',
	// 		'Phek',
	// 		'Tuensang',
	// 		'Wokha',
	// 		'Zunheboto',
	// ]
    // },
    // {
    //     name:'Orissa',
	// 	cities :[
    //             'Angul',
    //             'Boudh (Bauda)',
    //             'Bhadrak',
    //             'Balangir',
    //             'Bargarh (Baragarh)',
    //             'Balasore',
    //             'Cuttack',
    //             'Debagarh (Deogarh)',
    //             'Dhenkanal',
    //             'Ganjam',
    //             'Gajapati',
    //             'Jharsuguda',
    //             'Jajpur',
    //             'Jagatsinghpur',
    //             'Khordha',
    //             'Kendujhar (Keonjhar)',
    //             'Kalahandi',
    //             'Kandhamal',
    //             'Koraput',
    //             'Kendrapara',
    //             'Malkangiri',
    //             'Mayurbhanj',
    //             'Nabarangpur',
    //             'Nuapada',
    //             'Nayagarh',
    //             'Puri',
    //             'Rayagada',
    //             'Sambalpur',
    //             'Subarnapur (Sonepur)',
    //             'Sundergarh',
	// 	]
    // },
    // {
    //     name:'Pondicherry (Puducherry)',
    //     cities: [
	// 		'Karaikal',
	// 		'Mahe',
	// 		'Pondicherry',
	// 		'Yanam',
    //     ]
    // },
    // {
    //     name:'Punjab',
    //     cities: [
	// 		'Amritsar',
	// 		'Barnala',
	// 		'Bathinda',
	// 		'Firozpur',
	// 		'Faridkot',
	// 		'Fatehgarh Sahib',
	// 		'Fazilka',
	// 		'Gurdaspur',
	// 		'Hoshiarpur',
	// 		'Jalandhar',
	// 		'Kapurthala',
	// 		'Ludhiana',
	// 		'Mansa',
	// 		'Moga',
	// 		'Sri Muktsar Sahib',
	// 		'Pathankot',
	// 		'Patiala',
	// 		'Rupnagar',
	// 		'Ajitgarh (Mohali)',
	// 		'Sangrur',
	// 		'Nawanshahr',
	// 		'Tarn Taran',
	//     ]
    // },
    // {
    //     name:'Rajasthan',
    //     cities: [
	// 		'Ajmer',
	// 		'Alwar',
	// 		'Bikaner',
	// 		'Barmer',
	// 		'Banswara',
	// 		'Bharatpur',
	// 		'Baran',
	// 		'Bundi',
	// 		'Bhilwara',
	// 		'Churu',
	// 		'Chittorgarh',
	// 		'Dausa',
	// 		'Dholpur',
	// 		'Dungapur',
	// 		'Ganganagar',
	// 		'Hanumangarh',
	// 		'Jhunjhunu',
	// 		'Jalore',
	// 		'Jodhpur',
	// 		'Jaipur',
	// 		'Jaisalmer',
	// 		'Jhalawar',
	// 		'Karauli',
	// 		'Kota',
	// 		'Nagaur',
	// 		'Pali',
	// 		'Pratapgarh',
	// 		'Rajsamand',
	// 		'Sikar',
	// 		'Sawai Madhopur',
	// 		'Sirohi',
	// 		'Tonk',
	// 		'Udaipur',
	//     ]
    // },
    // {
    //     name:'Sikkim',
    //     cities: [
	// 		'East Sikkim',
	// 		'North Sikkim',
	// 		'South Sikkim',
	// 		'West Sikkim',
	//     ]
    // },
    // {
    //     name:'Tamil Nadu',
    //     cities: [
	// 		'Ariyalur',
	// 		'Chennai',
	// 		'Coimbatore',
	// 		'Cuddalore',
	// 		'Dharmapuri',
	// 		'Dindigul',
	// 		'Erode',
	// 		'Kanchipuram',
	// 		'Kanyakumari',
	// 		'Karur',
	// 		'Madurai',
	// 		'Nagapattinam',
	// 		'Nilgiris',
	// 		'Namakkal',
	// 		'Perambalur',
	// 		'Pudukkottai',
	// 		'Ramanathapuram',
	// 		'Salem',
	// 		'Sivaganga',
	// 		'Tirupur',
	// 		'Tiruchirappalli',
	// 		'Theni',
	// 		'Tirunelveli',
	// 		'Thanjavur',
	// 		'Thoothukudi',
	// 		'Tiruvallur',
	// 		'Tiruvarur',
	// 		'Tiruvannamalai',
	// 		'Vellore',
	// 		'Viluppuram',
	// 		'Virudhunagar',
	//     ]
    // },
    // {
    //     name:'Tripura',
    //     cities: [
	// 		'Dhalai',
	// 		'North Tripura',
	// 		'South Tripura',
	// 		'Khowai',
	// 		'West Tripura',
	//     ]
    // },
    // {
    //     name:'Uttar Pradesh',
    //     cities: [
	// 		'Agra',
	// 		'Allahabad',
	// 		'Aligarh',
	// 		'Ambedkar Nagar',
	// 		'Auraiya',
	// 		'Azamgarh',
	// 		'Barabanki',
	// 		'Budaun',
	// 		'Bagpat',
	// 		'Bahraich',
	// 		'Bijnor',
	// 		'Ballia',
	// 		'Banda',
	// 		'Balrampur',
	// 		'Bareilly',
	// 		'Basti',
	// 		'Bulandshahr',
	// 		'Chandauli',
	// 		'Chhatrapati Shahuji Maharaj Nagar',
	// 		'Chitrakoot',
	// 		'Deoria',
	// 		'Etah',
	// 		'Kanshi Ram Nagar',
	// 		'Etawah',
	// 		'Firozabad',
	// 		'Farrukhabad',
	// 		'Fatehpur',
	// 		'Faizabad',
	// 		'Gautam Buddh Nagar',
	// 		'Gonda',
	// 		'Ghazipur',
	// 		'Gorakhpur',
	// 		'Ghaziabad',
	// 		'Hamirpur',
	// 		'Hardoi',
	// 		'Mahamaya Nagar',
	// 		'Jhansi',
	// 		'Jalaun',
	// 		'Jyotiba Phule Nagar',
	// 		'Jaunpur district',
	// 		'Ramabai Nagar (Kanpur Dehat)',
	// 		'Kannauj',
	// 		'Kanpur',
	// 		'Kaushambi',
	// 		'Kushinagar',
	// 		'Lalitpur',
	// 		'Lakhimpur Kheri',
	// 		'Lucknow',
	// 		'Mau',
	// 		'Meerut',
	// 		'Maharajganj',
	// 		'Mahoba',
	// 		'Mirzapur',
	// 		'Moradabad',
	// 		'Mainpuri',
	// 		'Mathura',
	// 		'Muzaffarnagar',
	// 		'Panchsheel Nagar district (Hapur)',
	// 		'Pilibhit',
	// 		'Shamli',
	// 		'Pratapgarh',
	// 		'Rampur',
	// 		'Raebareli',
	// 		'Saharanpur',
	// 		'Sitapur',
	// 		'Shahjahanpur',
	// 		'Sant Kabir Nagar',
	// 		'Siddharthnagar',
	// 		'Sonbhadra',
	// 		'Sant Ravidas Nagar',
	// 		'Sultanpur',
	// 		'Shravasti',
	// 		'Unnao',
	// 		'Varanasi',
	//     ]
    // },
    // {
    //     name:'Uttarakhand',
    //     cities:[
	// 		'Almora',
	// 		'Bageshwar',
	// 		'Chamoli',
	// 		'Champawat',
	// 		'Dehradun',
	// 		'Haridwar',
	// 		'Nainital',
	// 		'Pauri Garhwal',
	// 		'Pithoragarh',
	// 		'Rudraprayag',
	// 		'Tehri Garhwal',
	// 		'Udham Singh Nagar',
	// 		'Uttarkashi',
	//     ]
    // },
    // {
    //     name:'West Bengal',
    //     cities: [
	// 		'Birbhum',
	// 		'Bankura',
	// 		'Bardhaman',
	// 		'Darjeeling',
	// 		'Dakshin Dinajpur',
	// 		'Hooghly',
	// 		'Howrah',
	// 		'Jalpaiguri',
	// 		'Cooch Behar',
	// 		'Kolkata',
	// 		'Maldah',
	// 		'Paschim Medinipur',
	// 		'Purba Medinipur',
	// 		'Murshidabad',
	// 		'Nadia',
	// 		'North 24 Parganas',
	// 		'South 24 Parganas',
	// 		'Purulia',
	// 		'Uttar Dinajpur',
	//     ]
    // }
    ];
};

export const batch = () => {
	return [
		'1998',
		'1999',
		'2000',
		'2001',
		'2002',
		'2003',
		'2004',
		'2005',
		'2006',
		'2007',
		'2008',
		'2009',
		'2010',
		'2011',
		'2012',
		'2013',
		'2014'
	];
};